<template>
  <div class="app-wrapper">
    <div class="app-main">
      <slot />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
